import { apiService } from './api';

export interface FavoriteLessonItemDto {
  id: number;
  lessonId: number;
  lessonTitle: string;
  lessonTitleFa?: string;
  lessonDescription?: string;
  levelTitle: string;
  levelTitleFa?: string;
  levelId: number;
  courseTitle: string;
  courseTitleFa?: string;
  courseId: number;
  createdAt: string;
  /** False when the lesson was withdrawn (trashed) or unpublished. */
  isAccessible?: boolean;
}

export interface FavoriteTagBlockItemDto {
  id: number;
  tagId: number;
  tagName: string;
  tagNameFa?: string;
  tagDescription?: string;
  tagDescriptionFa?: string;
  color: string;
  icon?: string;
  contentBlockId: number;
  blockTitle?: string;
  blockTitleFa?: string;
  lessonId: number;
  lessonTitle: string;
  lessonTitleFa?: string;
  levelTitle: string;
  levelTitleFa?: string;
  courseTitle: string;
  courseTitleFa?: string;
  createdAt: string;
  isAccessible?: boolean;
}

export interface FavoriteTagLessonItemDto {
  id: number;
  tagId: number;
  tagName: string;
  tagNameFa?: string;
  tagDescription?: string;
  tagDescriptionFa?: string;
  color: string;
  icon?: string;
  lessonId: number;
  lessonTitle: string;
  lessonTitleFa?: string;
  levelTitle: string;
  levelTitleFa?: string;
  courseTitle: string;
  courseTitleFa?: string;
  createdAt: string;
  isAccessible?: boolean;
}

export const favoriteService = {
  async getFavorites(): Promise<FavoriteLessonItemDto[]> {
    return apiService.get<FavoriteLessonItemDto[]>('/api/Favorites', { cache: false });
  },

  async getFavoriteLessonIds(): Promise<number[]> {
    return apiService.get<number[]>('/api/Favorites/ids', { cache: false });
  },

  async getFavoriteTags(): Promise<FavoriteTagBlockItemDto[]> {
    return apiService.get<FavoriteTagBlockItemDto[]>('/api/Favorites/tags', { cache: false });
  },

  async getFavoriteTagBlockIds(tagId: number): Promise<number[]> {
    return apiService.get<number[]>(`/api/Favorites/tags/${tagId}/block-ids`, { cache: false });
  },

  async getFavoriteTagLessonIds(tagId: number): Promise<number[]> {
    return apiService.get<number[]>(`/api/Favorites/tags/${tagId}/lesson-ids`, { cache: false });
  },

  async getFavoriteTagLessons(): Promise<FavoriteTagLessonItemDto[]> {
    return apiService.get<FavoriteTagLessonItemDto[]>('/api/Favorites/tags/lessons', { cache: false });
  },

  async addFavorite(lessonId: number): Promise<void> {
    await apiService.post(`/api/Favorites/${lessonId}`, {});
  },

  async removeFavorite(lessonId: number): Promise<void> {
    await apiService.delete(`/api/Favorites/${lessonId}`);
  },

  async addFavoriteTagBlock(tagId: number, blockId: number): Promise<void> {
    await apiService.post(`/api/Favorites/tags/${tagId}/blocks/${blockId}`, {});
  },

  async removeFavoriteTagBlock(tagId: number, blockId: number): Promise<void> {
    await apiService.delete(`/api/Favorites/tags/${tagId}/blocks/${blockId}`);
  },

  async addFavoriteTagLesson(tagId: number, lessonId: number): Promise<void> {
    await apiService.post(`/api/Favorites/tags/${tagId}/lessons/${lessonId}`, {});
  },

  async removeFavoriteTagLesson(tagId: number, lessonId: number): Promise<void> {
    await apiService.delete(`/api/Favorites/tags/${tagId}/lessons/${lessonId}`);
  },
};
